import { useMemo } from 'react';
import { capitalize } from 'lodash';

import { REGEXPS } from '@/common';

import type { CategorySpendLimit } from '../queries/useGetCategorySpendLimits.query';
import type { CategorySpendLimitRow } from '../types';

interface UseCategorySpendLimitsDataProps {
  categorySpendLimits: CategorySpendLimit[];
}

const formatCategoryType = (categoryType: string): string => {
  if (!categoryType) return '';
  return capitalize(categoryType).replace(REGEXPS.DASH_SYMBOL, ' ');
};

export const useCategorySpendLimitsData = ({
  categorySpendLimits = [],
}: UseCategorySpendLimitsDataProps): CategorySpendLimitRow[] => {
  return useMemo(() => {
    if (!categorySpendLimits.length) return [];

    return categorySpendLimits.map((limit) => ({
      id: `${limit.id}`,
      categoryType: limit.categoryType,
      categoryLabel: formatCategoryType(limit.categoryType),
      categorySpendLimit: limit.categorySpendLimit,
      totalSpent: limit.totalSpent,
    }));
  }, [categorySpendLimits]);
};
